import { injectLocal } from '@vueuse/core';
import { PRODUCT_DIVISION_CATEGORY_FLAGS_REPOSITORY } from '../../product/constants/providers';

export const useDivisionCategoryFlags = () => {
  const data = injectLocal(PRODUCT_DIVISION_CATEGORY_FLAGS_REPOSITORY);

  if (typeof data === 'undefined') {
    throw new TypeError('useDivisionCategoryFlags() is called without provider.');
  }

  return data;
};
